import React from 'react';
import { Link } from 'react-router-dom';

const PoliticaPrivacidad = () => {
  const currentYear = new Date().getFullYear(); // Renderiza dinámicamente el año actual (2026)

  return (
    <div className="w-full bg-slate-50 min-h-screen py-12 px-6 lg:px-16 text-left text-slate-700 font-sans">
      <div className="max-w-4xl mx-auto bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-slate-200/60 space-y-8 animate-fadeIn">
        
        {/* ENCABEZADO */}
        <div className="border-b border-slate-100 pb-6">
          <h1 className="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">
            Políticas de Privacidad
          </h1>
          <p className="text-sm text-slate-400 font-bold uppercase tracking-wider mt-2">
            Última actualización: Junio {currentYear}
          </p>
        </div>

        {/* INTRODUCCIÓN */}
        <p className="text-sm md:text-base leading-relaxed font-medium text-slate-600">
          En <span className="font-bold text-slate-900">Dufy Asesorías</span>, valoramos y respetamos profundamente tu privacidad. Esta Política de Privacidad describe cómo recopilamos, utilizamos, protegemos y manejamos tu información personal cuando utilizas nuestros servicios de soporte académico y consultoría a través de nuestra plataforma web y canales oficiales de comunicación.
        </p>

        {/* SECCIÓN 1 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">1.</span> Información que Recopilamos
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Para prestar un servicio de asesoría eficiente, oportuno y personalizado, recopilamos los siguientes datos de forma directa cuando te comunicas con nosotros:
          </p>
          <ul className="list-disc pl-5 text-sm font-semibold text-slate-600 space-y-1.5">
            <li><strong className="text-slate-800">Datos de contacto básicos:</strong> Nombre completo y número de teléfono celular (WhatsApp).</li>
            <li><strong className="text-slate-800">Información académica:</strong> Rúbricas de talleres, temarios de exámenes, guías, fechas de evaluación e institución educativa de origen.</li>
            <li><strong className="text-slate-800">Comprobantes de transacciones:</strong> Recibos o capturas de transferencias para verificar tus pagos reglamentarios.</li>
          </ul>
        </div>

        {/* SECCIÓN 2 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">2.</span> Confidencialidad y Anonimato Estricto
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Entendemos la naturaleza sensible de la asistencia académica. Por ello, aplicamos un protocolo riguroso de seguridad sobre tu identidad:
          </p>
          <div className="bg-emerald-50 border border-emerald-100 text-emerald-900 rounded-2xl p-4 text-xs md:text-sm font-bold leading-relaxed">
            Toda la evidencia de trabajos realizados expuesta en este sitio web (capturas de exámenes, calificaciones y testimonios) cuenta con la previa censura absoluta de nombres, códigos estudiantiles, correos y rostros, resguardando al 100% tu anonimato frente a terceros o instituciones académicas.
          </div>
        </div>

        {/* SECCIÓN 3 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">3.</span> Uso de la Información
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Los datos proporcionados se emplean única y exclusivamente para los siguientes fines operativos:
          </p>
          <ul className="list-disc pl-5 text-sm font-medium space-y-1.5">
            <li>Asignar un tutor especializado que cumpla exactamente con el perfil de tu asignatura.</li>
            <li>Coordinar las fases logísticas de resolución de tus guías o parciales en tiempo real.</li>
            <li>Procesar las solicitudes de garantías o devoluciones monetarias si el servicio lo amerita.</li>
          </ul>
        </div>

        {/* SECCIÓN 4 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">4.</span> Retención y Destrucción de Archivos
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            No almacenamos bases de datos eternas de tus evaluaciones académicas. Una vez concluido el servicio con éxito y expirado el plazo reglamentario para apelaciones de calificaciones o garantías, todos los documentos y chats compartidos son archivados bajo máxima encriptación o eliminados de forma definitiva de nuestros canales operativos.
          </p>
        </div>

        {/* SECCIÓN 5 */}
        <div className="space-y-3">
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight flex items-center gap-2">
            <span className="text-blue-600">5.</span> Tus Derechos
          </h2>
          <p className="text-sm leading-relaxed font-medium">
            Como titular de tus datos personales, tienes derecho en cualquier momento a solicitar la rectificación, actualización o eliminación completa de tu número telefónico o registros de chats de nuestros servidores de soporte.
          </p>
        </div>

        {/* PIE DE PÁGINA INTERNO */}
        <div className="border-t border-slate-100 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400 font-semibold">
            © {currentYear} Dufy Asesorías. Todos los derechos reservados.
          </p>
          <Link 
            to="/" 
            className="bg-slate-900 hover:bg-blue-600 text-white font-extrabold text-xs px-5 py-2.5 rounded-xl transition-colors shadow-sm"
          >
            Volver al Inicio
          </Link>
        </div>

      </div>
    </div>
  );
};

export default PoliticaPrivacidad;